<script lang="ts" setup>
import { removeLegacyFeedbackTab } from '~/utils/feedbackUrl';

const route = useRoute();
const { selectedSizeId } = storeToRefs(useCatalogStore());

const query = computed(() => {
  const routeQuery = removeLegacyFeedbackTab(route.query);

  return selectedSizeId.value ? { ...routeQuery, offer_id: selectedSizeId.value } : routeQuery;
});

const { reviews, averageRating } = storeToRefs(useFeedbackStore());
const { reviewsTotalCountPluralized } = useProductFeedback();
const isHydrated = useHydratedFlag();
const hasReviews = computed(() => isHydrated.value && reviews.value.length > 0);
const displayedAverageRating = computed(() => (isHydrated.value ? averageRating.value : '0.0'));
const displayedReviewsCount = computed(() => (isHydrated.value ? reviewsTotalCountPluralized.value : 'Нет отзывов'));
</script>

<template>
  <NuxtLink
    :to="{ query, hash: '#reviews' }"
    class="product-page__reviews-link"
  >
    <div class="flex items-center gap-1">
      <SvgoStar
        :class="hasReviews ? 'text-black' : 'text-black-40'"
        :font-controlled="false"
        class="size-3"
        filled
      />

      <span class="text-black">{{ displayedAverageRating }}</span>
    </div>

    {{ displayedReviewsCount }}
  </NuxtLink>
</template>

<style lang="scss" scoped>
.product-page {
  &__reviews-link {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: fit-content;
    padding: 8px;
    border: 1px solid $black-10;
    border-radius: 8px;
    background-color: $white;
    color: $blue;
    font-size: $text-xs;
    text-decoration: none;
    transition: all 0.3s;

    &:hover {
      color: $label-violet;
    }
  }
}
</style>
